var _path, _rect, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 47,
    viewBox: "0 0 62 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0169 25.0227L12.8446 39.3784C13.0064 39.8594 13.4572 40.1835 13.9648 40.1835H49.171C49.7054 40.1835 50.1734 39.8248 50.3122 39.3087L54.1658 24.985C54.4302 24.0023 53.4116 23.1672 52.4998 23.6191L43.9502 27.8563C43.3779 28.1399 42.6839 27.9175 42.383 27.3541L33.1805 10.1247C32.7467 9.31241 31.5917 9.2864 31.1217 10.0783L20.8081 27.4572C20.5012 27.9744 19.8547 28.1786 19.3064 27.9315L9.62254 23.5685C8.68204 23.1448 7.68809 24.045 8.0169 25.0227Z",
    stroke: "#20242E",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 45,
    width: 38,
    height: 2,
    rx: 1,
    fill: "#20242E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.1922,
    cy: 3.54741,
    rx: 3.57692,
    ry: 3.54545,
    fill: "#0E5CF4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.57692,
    cy: 20.0928,
    rx: 3.57692,
    ry: 3.54545,
    fill: "#0E5CF4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.4231,
    cy: 20.0928,
    rx: 3.57692,
    ry: 3.54545,
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeCrown);
export default __webpack_public_path__ + "static/media/ic-large-crown.61898627f225a70f6725f67b7d773d8b.svg";
export { ForwardRef as ReactComponent };